// マスタデータ取得用のURLマッピング設定
export const MASTER_DATA_URLS = {
  development_methods: '/development_method_autocomplete?query=',
  roles: '/role_autocomplete?query=',
  industries: '/industry_autocomplete?query=',
  tools: '/tool_autocomplete?query=',
  requirements_definition_operations: '/requirements_definition_operation_autocomplete?query=',
  basic_design_operations: '/basic_design_operation_autocomplete?query=',
  detail_design_operations: '/detail_design_operation_autocomplete?query=',
  program_operations: '/program_operation_autocomplete?query=',
  test_operations: '/test_operation_autocomplete?query=',
  maintenance_operations: '/maintenance_operation_operation_autocomplete?query=',
  frontend_languages: '/front_end_autocomplete?query=',
  backend_languages: '/back_end_autocomplete?query=',
  operating_systems: '/operating_system_autocomplete?query=',
  middlewares: '/middleware_autocomplete?query=',
  dbs: '/db_autocomplete?query=',
  networks: '/network_autocomplete?query=',
  design_tools: '/design_tool_autocomplete?query=',
  business_systems: '/business_system_autocomplete?query=',
  cloud_services: '/cloud_service_autocomplete?query=',
  server_operating_systems: '/server_operating_system_autocomplete?query='
};

// 関連データ取得用のURL生成関数
/**
 * ステップ8-9のフレームワーク・ライブラリのURL生成（フロントエンド・バックエンド両対応）
 * @param {string} languageName - 言語名
 * @param {string} languageType - 言語タイプ（'front_end' | 'back_end'）
 * @returns {string} フレームワーク取得用URL
 */
export const getFrameworkLibraryUrl = (languageName, languageType = 'front_end') =>
  `/fw_library_autocomplete?query=&language_name=${encodeURIComponent(languageName)}&type=${languageType}`;

// 後方互換性のためのエイリアス
export const getFrameworkUrl = getFrameworkLibraryUrl;

/**
 * ステップ10の業務システムの製品/言語のURL生成
 * @param {string} businessSystemName - 業務システム名
 * @returns {string} 製品/言語取得用URL
 */
export const getBusinessSystemProductLanguageUrl = (businessSystemName) =>
  `/business_system_product_language_autocomplete?query=&business_system_name=${encodeURIComponent(businessSystemName)}`;

/**
 * ステップ11のクラウドサービスの製品のURL生成
 * @param {string} cloudServiceName - クラウドサービス名
 * @returns {string} 製品取得用URL
 */
export const getCloudServiceProductUrl = (cloudServiceName) =>
  `/cloud_service_product_autocomplete?query=&cloud_service_name=${encodeURIComponent(cloudServiceName)}`;

/**
 * ステップ12のサーバー環境のURL生成
 * @param {string} serverOperatingSystemName - サーバーOS名
 * @returns {string} サーバー環境取得用URL
 */
export const getServerEnvironmentUrl = (serverOperatingSystemName) =>
  `/server_environment_autocomplete?query=&server_operating_system_name=${encodeURIComponent(serverOperatingSystemName)}`;

/**
 * ステップ13のミドルウェア製品のURL生成
 * @param {string} middlewareName - ミドルウェア名
 * @returns {string} 製品取得用URL
 */
export const getMiddlewareProductUrl = (middlewareName) =>
  `/middleware_product_autocomplete?query=&middleware_name=${encodeURIComponent(middlewareName)}`;
